import api from '../api';

const getJobProgress = async (requestId) => {
  const { data } = await api.get(`api/job/progress-data/request-id/${requestId}`);
  return data;
};

const getJobFileData = async (requestId) => {
  const { data } = await api.get(`api/job/file-data/${requestId}`);
  return data;
};

const getJobFileLink = async (requestId) => {
  const { data } = await api.get(`api/job/file/${requestId}`);
  return data;
};

const JobProgressService = {
  getJobProgress,
  getJobFileData,
  getJobFileLink,
};

export default JobProgressService;
